<template>
  <div class="relative">
    <div class="select_box" :class="{'active': active}">
      <div class="main flex align-center" @click="onSelect">
        <div class="flex-1">{{title}}</div>
        <i class="select_img el-icon-arrow-down" :class="{'select_img_rotate' : active}"></i>
      </div>
      <div class="list flex-column" v-if="active">
        <div class="flex-1 list-main">
          <div class="flex item align-center" v-for="(item, index) in list" :key="index" @click="onCheck(item)">
            <img :src="selectedList.indexOf(item.name) !== -1 ? '../../static/images/xuanzhong.png' : '../../static/images/weixuan.png'" class="mr-5" alt="">
            <div>{{item.name}}</div>
          </div>
        </div>
        <!--<div class="flex align-center justify-center bottom">-->
          <!--<div class="btn-12-bd-85 mr-5" @click="onReset">重置</div>-->
          <!--<div class="btn-12-bg-85" @click="onSubmit">确定</div>-->
        <!--</div>-->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'OptionCheck',
  components: {},
  props: {
    title: String,
    index: Number,
    isDepartment: Boolean
  },
  data () {
    return {
      active: false,
      list: [],
      selectedList: [],
      selectedId: [],
      arr: []
    }
  },
  created () {},
  mounted () {
  },
  methods: {
    onSelect () {
      this.active = !this.active
      if (this.active) {
        this.getDepartment(this.index)
      }
      // if (!this.active) {
      //   this.getDepartment(this.index)
      // } else {
      //   this.active = false
      // }
    },
    getDepartment (index) {
      let assignKey
      switch (index) {
        case 0:
          assignKey = 'submitSalesman'
          break
        case 1:
          assignKey = 'submitDesigner'
          break
        case 2:
          assignKey = 'submitCm'
          break
        case 3:
          assignKey = 'submitBe'
          break
        case 4:
          assignKey = 'submitPm'
          break
        case 5:
          assignKey = 'submitSu'
          break
        case 6:
          assignKey = 'submitAs'
          break
        case 7:
          assignKey = 'submitFail'
          break
      }
      this.axios.post(`${this.$store.state.API_URL_9010}/assignDefine/filterList`, {
        companyId: this.$store.state.companyId,
        assignKey: assignKey,
        filterFlag: true
      }).then(res => {
        if (res.data.success) {
          if (!this.isDepartment) {
            let test = this.$parent.$parent.$parent.department[this.index]
            if (test.selected.length === 0) {
              for (let i = 0; i < res.data.data.length; i++) {
                this.arr.push(res.data.data[i].id)
              }
            } else {
              this.arr = test.selected
            }
            this.getEmployee()
          } else {
            this.list = res.data.data
          }
          // this.active = true
        }
      })
    },
    onCheck (item) {
      if (this.selectedList.indexOf(item.name) === -1) {
        this.selectedList.push(item.name)
        this.selectedId.push(item.id)
      } else {
        this.selectedList.splice(this.selectedList.indexOf(item.name), 1)
        this.selectedId.splice(this.selectedId.indexOf(item.id), 1)
      }
      if (this.isDepartment) {
        this.$parent.$parent.$parent.department[this.index].selected = this.Utils.deepClone((this.selectedId))
        this.$parent.$parent.$parent.department[this.index].selected1 = this.Utils.deepClone((this.selectedList))
      } else {
        this.$parent.$parent.$parent.employee[this.index].selected = this.Utils.deepClone((this.selectedId))
        this.$parent.$parent.$parent.employee[this.index].selected1 = this.Utils.deepClone((this.selectedList))
      }
    },
    getEmployee () {
      if (this.arr.length > 0) {
        this.axios.post('employee/list', {departmentIds: this.arr.join(','), isShowSub: true, isQuit: 0, companyId: this.$store.state.companyId}).then(res => {
          if (res.data.success) {
            this.list = res.data.data
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      }
    }
    // onReset () {
    //   this.selectedList = []
    // },
    // onSubmit () {
    //   if (this.isDepartment) {
    //     this.$parent.$parent.$parent.department[this.index].selected = this.Utils.deepClone((this.selectedList))
    //   } else {
    //     this.$parent.$parent.$parent.employee[this.index].selected = this.Utils.deepClone((this.selectedList))
    //   }
    //   this.active = false
    // }
  }
}
</script>

<style lang="scss" scoped>
  .main{
    height: 30px;
    line-height: 30px;
    background-color: #ffffff;
    border-radius: 4px;
    border: solid 1px #e2e2e2;
    text-align: left;
    padding:  0 10px;
  }
  .mask{
    width: 100vw;
    height:100vh;
    position: fixed;
    top: 0;
    left:0;
    background: transparent;
    z-index: 9;
  }
  .select_box{
    position: relative;
    z-index: 10;
    cursor: pointer;
  }
  .active{
    z-index: 99;
  }
  .select_img{
    transition:transform 0.3s;
  }
  .select_img_rotate{
    transform:rotate(180deg);
  }
  .list{
    background: #fff;
    position: absolute;
    top: 30px;
    height: 400px;
    overflow-y: auto;
    left: 0;
    width: 100%;
    border: solid 1px #e2e2e2;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    box-shadow: 0px 0px 10px 0px
    rgba(0, 0, 0, 0.1);
    z-index: 11;
  }
  .list-main{
    padding: 0 10px;
  }
  .item{
    border-bottom: 1px dashed #e2e2e2;
    padding: 3px 0;
  }
  .item:last-child{
    border-bottom: none;
  }
  .bottom{
    border-top: 1px solid #e2e2e2;
    padding: 4px 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/customer/components/FiltrateOption.vue